"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChooseRole = void 0;
const react_1 = __importDefault(require("react"));
const theme_1 = require("../utils/theme");
const css_manager_1 = require("@food/css-manager");
const Button_1 = require("@food/ui/build/dist/src/Button");
const style = (0, css_manager_1.registerClass)((theme, sc) => `
	padding-top: ${theme.ratios.l * theme.font.baseSize}px;
	padding-bottom: ${theme.ratios.l * theme.font.baseSize}px;
	
	.${sc('role')} {
		margin-top: ${theme.ratios.s * theme.font.baseSize}px;
		
		&.first-child {
			margin-top: 0;
		}
	}
`);
const ChooseRole = ({ t, roles, authManager, back, roleChooser, }) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("h2", null, t `Registration`),
    react_1.default.createElement("section", { className: style },
        react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: t `Registration intro` } }),
        react_1.default.createElement("div", { className: style }, roles && roles.length > 0 && (react_1.default.createElement("div", null, roles.map((role) => {
            return (react_1.default.createElement(Button_1.Button, { key: role, type: 'success', label: t('Role ' + role), onClick: () => roleChooser(role), block: true, className: (0, css_manager_1.subClass)(style, 'role') }));
        })))),
        react_1.default.createElement("div", { className: theme_1.footer },
            react_1.default.createElement(Button_1.Button, { label: t `Back`, onClick: () => back() })))));
exports.ChooseRole = ChooseRole;
//# sourceMappingURL=ChooseRole.js.map